import React, { Fragment, useEffect, useState } from 'react';

import { Card, List, Skeleton, Typography } from 'antd';

import CobreFacil from 'lib/CobreFacil';
import { formatBRL } from 'lib/helpers/BRL';
import { useAccount } from 'lib/providers/AccountContextProvider';
import { Show } from 'lib/Show';

export function SettingsFinanceInfo() {
    const { clientManager, subscription, isLoading } = useAccount();
    const [localLoading, setLocalLoading] = useState(true);

    useEffect(() => {
        if (subscription || (!isLoading && subscription === null)) {
            setLocalLoading(false);
        }
    }, [isLoading, subscription]);

    const supportNumber = clientManager.contract === 'trial'
        ? 'https://wa.me/555191639123'
        : 'https://wa.me/5551991503329';

    const renderSubscriptionItem = (item: CobreFacil.Item) => (
        <List.Item>
            <Typography.Text>
                {item.description}: {formatBRL(parseFloat(item.price))}{' '}
                {item.number_installments > 1 &&
                    `parcela ${item.generated_installments} de ${item.number_installments}`}
            </Typography.Text>
        </List.Item>
    );

    const renderSubscriptionList = () => {
        if (!subscription) return null;

        const total = subscription.items.reduce(
            (acc, obj) => acc + (parseFloat(obj.price) || 0),
            0
        );

        return (
            <List
                dataSource={subscription.items}
                renderItem={renderSubscriptionItem}
                footer={
                    <Typography.Text strong>Total: {formatBRL(total)}</Typography.Text>
                }
            />
        );
    };

    const financeMessage =
        clientManager.contract !== 'trial' && !subscription
            ? 'Sua empresa está em processo de implantação, estamos finalizando a configuração do seu plano.'
            : clientManager.contract === 'trial'
                ? (
                    <>
                        Você ainda não contratou nenhum plano.{' '}
                        <Typography.Link href={supportNumber} target="_blank" strong>
                            Clique aqui e entre em contato conosco
                        </Typography.Link>{' '}
                        para encontrar o plano ideal.
                    </>
                )
                : null;



    const cardTitle = localLoading
        ? <Skeleton.Input active size="small" style={{ width: 120 }} />
        : subscription?.plans_id
            ? CobreFacil.findPlan(subscription.plans_id)?.name
            : 'Plano';

    const hasMessage = !localLoading && financeMessage !== null;

    return (
        <Fragment>
            <Card title={cardTitle}>

                <Show when={hasMessage}>
                    <Typography.Text>{financeMessage}</Typography.Text>
                </Show>

                <Show when={!localLoading}>
                    {renderSubscriptionList()}
                </Show>
            </Card>
            <Show when={subscription !== null}>
                <Card loading={localLoading} title="Histórico de faturas e notas fiscais" style={{ marginTop: 12 }}>
                    <Typography.Text type="secondary">
                        Em breve você poderá acessar o histórico de faturas e notas fiscais aqui.
                    </Typography.Text>
                </Card>
            </Show>
        </Fragment>
    );
}
